import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { Globals } from '../../../services/globals';
import { ApiService } from '../../../services/api.service';
import { LIST_TAG_NAMES, RCS_TAGS_LIST, WHATSAPP_TAGS_LIST } from '../../../../config';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-more-filters',
  templateUrl: './more-filters.component.html',
  styleUrls: ['./more-filters.component.scss']
})
export class MoreFiltersComponent implements OnInit, OnChanges {
  
  @Input( ) moreFiltersByMaster : any;
  @Input( ) moreFiltersByMap : any;

  @Input( ) allStatusList : any;
  @Input( ) allStatusListMap : any;
  @Input( ) sq_id : any;
  @Input() channelList:any;
  channelListFilter=[];
  @Input() channelListMap:any;

  @Input() soipFilter:boolean = false;
  @Input( ) page:string = 'report';
  @Input() dateFilter:string = '';

  @Output() onApplyBtnClick = new EventEmitter< any >();
  @Output() filterData = new EventEmitter< any >();
  @Output() onSingleDeleteClick = new EventEmitter< any >();
  @Output() onClearFilterClick = new EventEmitter< any >();
  @Output() filterListEmitter = new EventEmitter< any >();
  savedMoreFilterList: any[];
  selectedMoreFilters = [];
  deletedMoreFilters = [];
  addMoreFiltersList : any = [];
  addMoreFiltersListCounts = 0;
  tempDeleteFiltersList : any = [];
  
  moreFiltersBy : any;
  newFormDataObj : any;
  deleteIconImg = '';
  filterStatusAll : boolean = false;  // initial flag for All option in more filters
  
  
  isTagFilterPresent : boolean = false;  // initial flag for tag filter to decide calling tag api
  showOpensFilter : boolean = false;   // initial flag for open status filter field
  domainName: any;
  tags: any;
  tagItems : any = [];
  openType : any = 1;

  popRef: NgbActiveModal;
  @Input() moreFiltersForm : UntypedFormGroup;
  hashEnabled: any;
  moreFiltersByFiltered= [];
  tagItemsFilter: any = [];
  

  constructor( private modalService: NgbModal, public globals: Globals, 
               private apiService: ApiService,private dataService:DataService ) {

    this.deleteIconImg = this.globals.getTableDeleteIcon( );
    this.domainName = globals.selected; 
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("moreFiltersByMaster", this.moreFiltersByMaster);
    if(changes.sq_id && changes.sq_id.previousValue!=changes.sq_id.currentValue){
      if(this.sq_id === 'all'){
        this.resetReport( )
      }
      this.onDeleteMoreFilterClick(this.moreFiltersForm,this.sq_id);
      this.applyMoreFilters(this.moreFiltersForm);
    }
    if(changes?.dateFilter && changes?.dateFilter?.previousValue!= changes?.dateFilter?.currentValue)
      this.fetchAlltags( );
    
    // Handle changes to moreFiltersByMaster and moreFiltersByMap
    if(changes?.moreFiltersByMaster && changes?.moreFiltersByMaster?.currentValue){
      // Filter out already selected filters
      if(this.selectedMoreFilters && this.selectedMoreFilters.length > 0){
        this.moreFiltersBy = this.moreFiltersByMaster.filter( elem => ( ! this.selectedMoreFilters.includes( elem.id ) ) );
      } else {
        this.moreFiltersBy = this.moreFiltersByMaster;
      }
      this.moreFiltersByFiltered = this.moreFiltersBy;
      
      // Check if tag filter is present
      this.moreFiltersByMaster.forEach( elem => {
        if( elem.id == 5 ){
          this.isTagFilterPresent = true;
          if(!this.tagItems || this.tagItems.length === 0) {
            this.fetchAlltags( );
          }
        }
      });
    }
    
    if(changes?.moreFiltersByMap && changes?.moreFiltersByMap?.currentValue){
      // Update the map if needed
      // The map is already updated in the parent component
    }
  }

  ngOnInit() {
    this.dataService.isHashEnabled$.subscribe(res=>{
      this.hashEnabled = res;
    })
    this.moreFiltersBy = this.moreFiltersByMaster;
    this.moreFiltersByFiltered = this.moreFiltersByMaster;
    

    this.moreFiltersByMaster.forEach( elem => {
        if( elem.id == 5 ){
          this.isTagFilterPresent = true;
          this.fetchAlltags( );      
        }
    });
    this.channelListFilter=this.channelList;
  }

  ngAfterViewInit( ){
  }

  resetReport( ){    // on click of clear filter

    this.onClearFilterClick.emit( );
  }

  openMoreFilterComponent(moreFilter) {

    this.tempDeleteFiltersList = [];

		if( this.addMoreFiltersList.length == 0 ){
			this.initializeMoreFilter( );
		}

		this.popRef = this.modalService.open(moreFilter, {windowClass: 'right-side-modal', backdrop: 'static'});
	}

  
  clearAllMoreFilters( ){
		
    this.savedMoreFilterList = [];
		this.selectedMoreFilters = [];
		this.addMoreFiltersList = [];
		this.addMoreFiltersListCounts = 0;
		this.deletedMoreFilters = [];
		this.moreFiltersBy = this.moreFiltersByMaster;

	}

  prefillMoreFilter( savedMoreFilterList : any = [ ] ){
    
    this.clearAllMoreFilters( );

    this.savedMoreFilterList = savedMoreFilterList;

    let livefeedStatusFilterSq = 0;  // variable to store status sequence no. incase of open type

    if( this.savedMoreFilterList.length > 0 ){    // if saved filter present

      this.savedMoreFilterList.forEach( elem => {

          this.addMoreFiltersListCounts++;
          
          let newFormDataObj = {};

          if( ! this.newFormDataObj ){
            this.newFormDataObj = { 
              ["filter_sq_id_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( elem.filter_id, [ Validators.required ]), 
              ["filter_sq_cond_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( elem.filter_cond, [ ])
            };
            newFormDataObj = this.newFormDataObj;
          }
          else{
            newFormDataObj = this.newFormDataObj;
            newFormDataObj["filter_sq_id_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filter_id, [ Validators.required ]); 
            newFormDataObj["filter_sq_cond_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filter_cond, [ ] );
          }

          newFormDataObj["filter_sq_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filter_val, [ ] ); 
          newFormDataObj["filter_sq_status_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( '', [ ] ); 
          newFormDataObj["filter_sq_batchid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl('', []);
          newFormDataObj["filter_sq_deliveryIPid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl('', []);
          newFormDataObj["filter_sq_IPPoolid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl('', []);
          newFormDataObj["filter_sq_tag_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( '', [ ] );
          newFormDataObj["filter_sq_channel_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( '', [ ] ); 
          newFormDataObj["filter_sq_openType_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( '1', [ ] ); 
          
          if( elem.filter_id == 4 ){  // for status filter

            let statusArr = JSON.parse( elem.filter_val_status );
            statusArr = statusArr.map( el => el.toString( ) );
            newFormDataObj["filter_sq_status_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( statusArr, [ ] ); 
            livefeedStatusFilterSq = this.addMoreFiltersListCounts;
          }

          if( elem.filter_id == 5 ){  // for tag
            newFormDataObj["filter_sq_tag_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filter_val, [ ] ); 
          }

          if(elem.filter_id == 6){
            newFormDataObj["filter_sq_channel_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filter_val, [ ] );
          }
          if( elem.filter_id == 26 ){  // for amp
            
            newFormDataObj["filter_sq_mailType_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filter_val, [ ] ); 
          }
          if (elem.filter_id == 27) { // for batch id
            newFormDataObj["filter_sq_batchid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl(elem.filter_val, []);
          }
          if (elem.filter_id == 28) { // for delivery IP id
            newFormDataObj["filter_sq_deliveryIPid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl(elem.filter_val, []);
          }
          if(elem.filter_id == 29) {
            newFormDataObj["filter_sq_IPPoolid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl(elem.filter_val, []);
          }

          //if( elem.filter_id == 12 || elem.filter_id == 11 ){  // for bot open
          if( elem.filter_id == 11 && elem.filter_val ){  // for bot open  
            
            this.openType = elem.filter_val;
            
            if ( elem.filter_source != 1 ) {  // if not summary report filter
              this.showOpensFilter = true;
              newFormDataObj["filter_sq_openType_val_"+livefeedStatusFilterSq] = new UntypedFormControl( elem.filter_val, [] ); 

            }
            else{
              newFormDataObj["filter_sq_openType_val_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filter_val, [] ); 
            }
            
          }

          this.newFormDataObj = newFormDataObj;
          this.moreFiltersForm = new UntypedFormGroup( newFormDataObj );
          
          if(  elem.filter_id != 11 || elem.filter_source == "1" ){
  
            let newItem = this.getNewCardItem( );
            this.addMoreFiltersList.push( newItem ); 
            this.selectedMoreFilters.push( parseInt( elem.filter_id  ) );
            this.filterListEmitter.emit(this.addMoreFiltersList);
          }

      });

    }
	}

  initializeMoreFilter( ){
		this.addMoreFiltersListCounts++;
		let newItem = this.getNewCardItem( );
		
    this.addMoreFiltersList.push( newItem );  
    this.filterListEmitter.emit(this.addMoreFiltersList);
		this.newFormDataObj = { 
			["filter_sq_id_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( '', [ Validators.required ]), 
			["filter_sq_cond_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( 1, [ ]), 
			["filter_sq_val_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( '', [ ]), 
			["filter_sq_status_val_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( '', [ ]),
      ["filter_sq_batchid_val_" + this.addMoreFiltersListCounts]: new UntypedFormControl('', []), 
      ["filter_sq_deliveryIPid_val_" + this.addMoreFiltersListCounts]: new UntypedFormControl('', []),
      ["filter_sq_IPPoolid_val_" + this.addMoreFiltersListCounts]: new UntypedFormControl('', []),                  
			["filter_sq_tag_val_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( '', [ ]),
			["filter_sq_channel_val_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( '', [ ]), 
			["filter_sq_mailType_val_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( '', [ ]), 

      ["filter_sq_openType_val_"+this.addMoreFiltersListCounts] :  new UntypedFormControl( '1', [ ]), 
		};
		this.moreFiltersForm = new UntypedFormGroup( this.newFormDataObj );
	}

  onAddMoreFilterClick( moreFiltersFormData, addFilterFlag = true ){
		moreFiltersFormData = moreFiltersFormData.getRawValue( );
		this.selectedMoreFilters = [];
		this.moreFiltersBy = this.moreFiltersByMaster;

		let addNewCard = true;   // boolean whethr to allow adding new card on add more click

		for (let i = 1; i <= this.addMoreFiltersListCounts; i++ ) {  // loop through filter counts	
      this.moreFiltersForm.get( 'filter_sq_id_'+i ).markAsTouched( );          // filter by
      this.moreFiltersForm.get( 'filter_sq_val_'+i ).markAsTouched( );         // filter input value
      this.moreFiltersForm.get( 'filter_sq_status_val_'+i ).markAsTouched( );   // filter status value 
      this.moreFiltersForm.get('filter_sq_batchid_val_' + i).markAsTouched();
      this.moreFiltersForm.get('filter_sq_deliveryIPid_val_' + i).markAsTouched();
      this.moreFiltersForm.get('filter_sq_IPPoolid_val_' + i).markAsTouched();      
      this.moreFiltersForm.get( 'filter_sq_tag_val_'+i ).markAsTouched( );
      this.moreFiltersForm.get( 'filter_sq_channel_val_'+i ).markAsTouched( ); 
      this.moreFiltersForm.get( 'filter_sq_mailType_val_'+i ).markAsTouched( );   // filter input value 
        // filter input value 
      this.moreFiltersForm.get( 'filter_sq_openType_val_'+i ).markAsTouched( );   // filter input value 

			if( moreFiltersFormData[ 'filter_sq_id_'+i ] ){  // if filter present

				// check value is not empty
				if( moreFiltersFormData[ 'filter_sq_val_'+i ] || moreFiltersFormData[ 'filter_sq_status_val_'+i ] || moreFiltersFormData[ 'filter_sq_tag_val_'+i ] || moreFiltersFormData[ 'filter_sq_channel_val_'+i ]  || moreFiltersFormData[ 'filter_sq_openType_val_'+i ] || moreFiltersFormData['filter_sq_batchid_val_' + i] || moreFiltersFormData['filter_sq_deliveryIPid_val_' + i] || moreFiltersFormData['filter_sq_IPPoolid_val_'] || moreFiltersFormData[ 'filter_sq_openType_val_'+i ] ){
					this.selectedMoreFilters.push( parseInt( moreFiltersFormData[ 'filter_sq_id_'+i ] ) );
					this.moreFiltersForm.patchValue( { [ 'filter_sq_id_'+i ] : moreFiltersFormData[ 'filter_sq_id_'+i ] } )
					this.moreFiltersForm.controls['filter_sq_id_'+i].disable();
				}
				else{
					addNewCard = false;
					break;	
				}
			}
			else if( ! this.deletedMoreFilters.includes( i ) ){  // if also not include in deleted filter sequence list
				addNewCard = false;
			}
		}

		if( this.selectedMoreFilters.length >= 7 || addFilterFlag == false ){  	// if all filters added
			addNewCard = false;
		}

		if( addNewCard ){

			let moreFiltersBy = this.moreFiltersBy.filter( elem=> ( ! this.selectedMoreFilters.includes( elem.id ) ) );

			this.moreFiltersBy = moreFiltersBy;			
			this.addMoreFiltersListCounts++;      
			let newItem = this.getNewCardItem( );			
			this.addMoreFiltersList.push( newItem ); 
			var newFormDataObj = this.newFormDataObj;

			newFormDataObj[ "filter_sq_id_"+this.addMoreFiltersListCounts] = new UntypedFormControl( '', [ Validators.required ]); 
			newFormDataObj[ "filter_sq_cond_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( 1, []);
			newFormDataObj[ "filter_sq_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( '', []);
			newFormDataObj[ "filter_sq_status_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl('',[]);
      newFormDataObj["filter_sq_batchid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl('', []);
      newFormDataObj["filter_sq_deliveryIPid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl('', []);
      newFormDataObj["filter_sq_IPPoolid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl('', []);      
			newFormDataObj[ "filter_sq_tag_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl('',[]);
			newFormDataObj[ "filter_sq_channel_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl('',[]);
      newFormDataObj[ "filter_sq_mailType_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl('',[]);

      newFormDataObj[ "filter_sq_openType_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl('1',[]);

			this.moreFiltersForm = new UntypedFormGroup( this.newFormDataObj );
		}
		else{
			let moreFiltersBy = this.moreFiltersBy.filter( elem=> ( ! this.selectedMoreFilters.includes( elem.id ) ) );
			this.moreFiltersBy = moreFiltersBy;
		}

    this.filterListEmitter.emit(this.addMoreFiltersList);
	}

  // private markFormGroupTouched(formGroup: UntypedFormGroup) {
  //   (<any>Object).values(formGroup.controls).forEach(control => {
  //     control.markAsTouched();
  
  //     if (control.controls) {
  //       this.markFormGroupTouched(control);
  //     }
  //   });
  // }

  applyMoreFilters( moreFiltersFormData_ ){
    if(!moreFiltersFormData_)
      return;
    let emitData = {
        'formData' : moreFiltersFormData_,
        'listCounts' : this.addMoreFiltersListCounts
    }

    this.selectedMoreFilters = [];
    let moreFiltersFormData = moreFiltersFormData_?.getRawValue( );
  
    // let isLivefeedOpen = false;
    // let statusField = '';
    for (let i = 1; i <= this.addMoreFiltersListCounts; i++ ) {

      let filter_id = moreFiltersFormData[ 'filter_sq_id_'+i ];
      
      if( filter_id  ){
        
        this.selectedMoreFilters.push( filter_id );
      }
      
    }

    // console.log( " this.moreFiltersForm emitData ", emitData )
    // console.log( " this.moreFiltersForm.controls ", this.moreFiltersForm.controls )
    // if( this.moreFiltersForm.controls[item.filterByField].value == 4 && showOpensFilter ){
    // }

    
    this.onApplyBtnClick.emit( emitData );
    this.filterData.emit( this.selectedMoreFilters );
    this.popRef?.close();
  }

  deleteFromChips(sq_id){
    this.onDeleteMoreFilterClick(this.moreFiltersForm,sq_id);
  }

  onDeleteMoreFilterClick( moreFiltersFormData_, sq_id ){   // on delete of specific 
		
		let moreFiltersFormData = moreFiltersFormData_.getRawValue( );

		this.deletedMoreFilters.push( sq_id );

    let filter_id = moreFiltersFormData[ 'filter_sq_id_'+ sq_id ];  // get filter number

		// unset deleted filter in moreFilters Form
		this.moreFiltersForm.patchValue( { [ 'filter_sq_id_' + sq_id ] : "" } )  

		let addMoreFiltersList = this.addMoreFiltersList.filter( ( el ) => ( el.sq != sq_id ) )
		
    this.addMoreFiltersList = addMoreFiltersList;

    let tempDeleteData = { 'sq' : sq_id, 
                            'filterByField'   : moreFiltersFormData[ 'filter_sq_id_'+sq_id ],
                            'filterCondField' : moreFiltersFormData[ 'filter_sq_cond_'+sq_id ] ,
                            'filterValField'  : moreFiltersFormData[ 'filter_sq_val_'+sq_id ] ,	
                            'filterStatusValField'  : moreFiltersFormData[ 'filter_sq_status_val_'+sq_id ],
                            'filterBatchIdValField': moreFiltersFormData['filter_sq_batchid_val_' + sq_id],
                            'filterdeliveryIPValField': moreFiltersFormData['filter_sq_deliveryIPid_val_' + sq_id],
                            'filterIPPoolValField': moreFiltersFormData['filter_sq_IPPoolid_val_' + sq_id],		                            			
                            'filterTagValField'  : moreFiltersFormData[ 'filter_sq_tag_val_'+sq_id ]	,
                            'filterChannelValField'  : moreFiltersFormData[ 'filter_sq_channel_val_'+sq_id ]	,

                            'filterMailTypeValField'  : moreFiltersFormData[ 'filter_sq_mailType_val_'+sq_id ]  ,

                            'filterBotOpenValField'  : moreFiltersFormData[ 'filter_sq_openType_val_'+sq_id ]  
                          }
    this.tempDeleteFiltersList.push( tempDeleteData );

    let emitData = {
      'formData' : moreFiltersFormData_,
      'filter_id' : filter_id 
    }

    this.filterListEmitter.emit(this.addMoreFiltersList);
    this.onSingleDeleteClick.emit( emitData );

	}

  cancelMoreFilters( ){   
    let insertIndex = this.addMoreFiltersList.length - 1;  
    this.tempDeleteFiltersList.forEach( elem => {
      
      this.addMoreFiltersListCounts++;

      let newItem = this.getNewCardItem( );			
      this.addMoreFiltersList.splice( insertIndex++ , 0 , newItem );
			var newFormDataObj = this.newFormDataObj;

			newFormDataObj[ "filter_sq_id_"+this.addMoreFiltersListCounts] = new UntypedFormControl( elem.filterByField , [ Validators.required ]); 
			newFormDataObj[ "filter_sq_cond_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( elem.filterCondField, []);
			newFormDataObj[ "filter_sq_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( elem.filterValField, []);
			newFormDataObj[ "filter_sq_status_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( elem.filterStatusValField,[]);
      newFormDataObj["filter_sq_batchid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl(elem.filterBatchIdValField, []);
      newFormDataObj["filter_sq_deliveryIPid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl(elem.filterdeliveryIPValField, []);
      newFormDataObj["filter_sq_IPPoolid_val_" + this.addMoreFiltersListCounts] = new UntypedFormControl(elem.filterIPPoolValField, []);      
			newFormDataObj[ "filter_sq_tag_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( elem.filterTagValField ,[]);
			newFormDataObj[ "filter_sq_channel_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( elem.filterChannelValField ,[]);
      newFormDataObj[ "filter_sq_mailType_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( elem.filterMailTypeValField ,[]);
      newFormDataObj[ "filter_sq_openType_val_" + this.addMoreFiltersListCounts ] = new UntypedFormControl( elem.filterBotOpenValField ,[]);

			this.moreFiltersForm = new UntypedFormGroup( this.newFormDataObj );

    });
    this.filterListEmitter.emit(this.addMoreFiltersList);
    this.popRef.close( );
  }

  getNewCardItem( ){

		let cardOptions = { 'sq' : this.addMoreFiltersListCounts, 
							'filterByField'   :  'filter_sq_id_'+this.addMoreFiltersListCounts,
							'filterCondField' :  'filter_sq_cond_'+this.addMoreFiltersListCounts,
							'filterValField'  :  'filter_sq_val_'+this.addMoreFiltersListCounts,	
							'filterStatusValField'  :  'filter_sq_status_val_'+this.addMoreFiltersListCounts,		

          }; 
		return cardOptions;							
	}

  toggleStatusSelect( sq_num, status ){ 

    if ( this.filterStatusAll ) {  
      this.changeStatusAllOption( sq_num );
      return false;
    }
    if( this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].value.length==this.allStatusList.length )
     this.changeStatusAllOption( sq_num, true )

    if( this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].value.indexOf("2") !== -1 ){   // if status is open
      this.showOpensFilter = true;
    }
    else{
      this.showOpensFilter = false;
    } 

  }

  toggleAllSelection( e, sq_num ) {
    this.filterStatusAll = ! this.filterStatusAll;

    if (this.filterStatusAll ) {

      let selectAll = [ ...this.allStatusList.map(item => item.value), "all" ];
      this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].patchValue( selectAll );
      this.showOpensFilter = true;
    } else {
      this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].patchValue([]);
      this.showOpensFilter = false;
    }
  }

  changeStatusAllOption( sq_num, status = false ){

    let currentStatus = this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].value;
    
    if( status ){   // to check option ALL
      currentStatus.push( "all" );
      this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].patchValue( currentStatus );  
    }
    else{    // to uncheck option All
      this.filterStatusAll = false;
      currentStatus = currentStatus.filter( item => ( item != 'all' ) )
      this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].patchValue( currentStatus );
    }

  }

  fetchAlltags( domainName : string = '' ) {

    this.domainName = ( domainName ) ? domainName : "All";

    if (this.soipFilter == false)
      this.apiService.get(LIST_TAG_NAMES + '?domain_like=' + this.domainName)
        .subscribe((result) => {
          if (result['status'] === 'success') {
            this.tags = result['data']['tag_list']['data'];
            // const arr = [ { value : "", text : 'All data' } ];
            const arr = [];
            for (const key in this.tags) {
              if (this.tags.hasOwnProperty(key)) {
                arr.push({ value: this.tags[key]['tag'], text: this.tags[key]['tag'] });
              }
            }
            this.tagItems = arr;
            this.tagItemsFilter = arr;
          }
        }
        );
    else
      this.apiService.get(RCS_TAGS_LIST + this.dateFilter.replace('&','?')).subscribe((res) => {
        if (res && res.data) {
          this.tagItems = res.data;
          this.tagItemsFilter = res.data;
        } else {
          // this.notification.showError(res.message);
        }
      });

  }

  onKey(value) {
    if (value) {
      this.moreFiltersByFiltered = this.search(value);
    } else {   
      this.moreFiltersByFiltered = this.moreFiltersBy;
    }
  }
  search(value: string) {
    let filter = value.toLowerCase();
    return this.moreFiltersBy.filter((option) =>
      option.name.toLowerCase().includes(filter)
    );
  }
  onKey2(value) {
    if (value) {
      this.channelListFilter = this.search2(value);
    } else {   
      this.channelListFilter = this.channelList;
    }
  }
  search2(value: string) {
    let filter = value.toLowerCase();
    return this.channelList.filter((option) =>
      option.text.toLowerCase().includes(filter)
    );
  }
  onKey3(value) {
    if (value && this.soipFilter==false) {
      this.tagItemsFilter = this.search3(value);
    } else if (value && this.soipFilter == true){   
      this.tagItemsFilter = this.search4(value);
    } else {
      this.tagItemsFilter = this.tagItems;
    }
  }
  search3(value: string) {
    let filter = value.toLowerCase();
    return this.tagItems.filter((option) =>
      option.text.toLowerCase().includes(filter)
    );
  }

  resetcondition(sq){
  this.moreFiltersForm.controls['filter_sq_cond_'+sq].reset();
  }
  
  search4(value: string) {
    let filter = value.toLowerCase();
    return this.tagItems.filter((option) =>
      option.toLowerCase().includes(filter)
    );
  }

}
